module.exports = __webpack_public_path__ + "img/heart-animation.a1599a48.gif";